export function isAlpha(c: string) {
  return (c >= 'A' && c <= 'Z') || (c >= 'a' && c <= 'z');
}

export function isDigit(c: string) {
  return c >= '0' && c <= '9';
}

export function isAlphaNum(c: string) {
  return isAlpha(c) || isDigit(c);
}
